import { Model } from 'vue-api-query'
Model.$http = axios
